import { useEditorStatuses } from "./editorStatus";
import FitmentFieldsSettings from "./FitmentFieldsSettings";
import SettingsPageLayout from "./SettingsPageLayout";

const editors = ["fields"] as const;

export default function SelectorFieldsSettingsPage() {
    const { report, form } = useEditorStatuses(editors);
    return (
        <SettingsPageLayout form={form}>
            <FitmentFieldsSettings section="fields" onStatusChange={report.fields} />
        </SettingsPageLayout>
    );
}
